let timer: ReturnType<typeof setTimeout> | null = null;

export function toast(message: string, ms = 2600): void {
  const el = document.getElementById('toast')!;
  el.textContent = message;
  el.hidden = false;
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    el.hidden = true;
  }, ms);
}
